import {
  CalendarDays,
  Settings,
  Heart,
  CircleCheck,
  MessageSquare
} from 'lucide-react';

import { isStandaloneApp } from '@/helpers/pwaHelpers';
import { cn } from '@/utils';
import { useToken } from '@/context/useToken';

import NotificationDotForNavigation from '@/app/conversation/NotificationDotForNavigation';

import NavItem from './navigation/NavItem';
import CardNavItem from './navigation/CardNavItem';

const Navigation = () => {
  const { token } = useToken();

  return (
    <div
      className={cn(
        'fixed bottom-0 w-full max-w-[598px] mx-auto flex justify-between px-6 py-3 border-t bg-background z-10',
        {
          'pb-6': isStandaloneApp()
        }
      )}
    >
      <NavItem icon={<CalendarDays />} label="Home" pathname="/" exact />
      {token && <CardNavItem />}
      <NavItem icon={<Heart />} label="Favourites" pathname="/favourites" />
      <NavItem icon={<CircleCheck />} label="Bookings" pathname="/booking" />
      <NavItem
        icon={<MessageSquare />}
        label="Inbox"
        pathname={`/conversation`}
        NotificationComponent={token ? <NotificationDotForNavigation /> : null}
      />
      <NavItem icon={<Settings />} label="Settings" pathname="/setting" />
    </div>
  );
};

export default Navigation;
